module.exports = __webpack_public_path__ + "img/b0309_13.cd04b7fd.png";